require('./chartTooltip.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { FormattedText } = require('core/i18n').i18n;
// const Immutable = require('immutable');
const moment = require('moment');
const { getLanguage } = require('core/i18n').i18n;
// const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const {
    OneLineSymbolAmount,
} = require('commonsComponents/oneLineSymbolAmount');

class chartTooltip extends React.Component {
    constructor(props) {
        super(props);

        this.buildTitleTotalExpenses = this.buildTitleTotalExpenses.bind(this);
        this.getTotalDetail = this.getTotalDetail.bind(this);
    }

    // Function to return translate text
    buildTitleTotalExpenses(type) {
        const title = type === 'TotalDebit' ? 'debitLegend' : 'creditLegend';
        return title;
    }

    //Function to get the total amount
    getTotalDetail(payload) {
        let totalValue = 0;
        payload.map(payload => {
            if (payload.dataKey !== 'TotalLastYear') {
                totalValue += payload.value;
            }
        });

        return totalValue;
    }

    render() {
        const { payload, label, type, periodTime, currency } = this.props;
        const yearTitle = `${label} ${
            payload[0] ? payload[0].payload.year : ''
        }`;
        const title =
            periodTime === 'D'
                ? `${label}/${moment().format('MMMM')}`
                : yearTitle;
        return (
            <div className="chart-tooltip">
                <div className="chart-tooltip__detail">
                    <span className="chart-tooltip__detail-title">{title}</span>
                    {payload.map(payload => {
                        if (payload.dataKey !== 'TotalLastYear') {
                            return (
                                <div
                                    key={payload.dataKey}
                                    className="chart-tooltip__detail-content row"
                                >
                                    <span className="col-xs-6">
                                        {type === 'totalExpenses' && (
                                            <FormattedText
                                                value={`historic-${this.buildTitleTotalExpenses(
                                                    payload.name,
                                                )}`}
                                            />
                                        )}
                                        {type === '' && payload.name}
                                    </span>
                                    <span className="col-xs-6">
                                        <OneLineSymbolAmount
                                            language={getLanguage()}
                                            positiveAmount
                                            amountObject={{
                                                amount: payload.value,
                                                currencySymbol: currency,
                                            }}
                                            amountObjectFormatted={{
                                                currencySymbol: currency,
                                            }}
                                        />
                                    </span>
                                </div>
                            );
                        }
                    })}
                </div>
                <div className="chart-tooltip__total">
                    <div className="row">
                        <span className="col-xs-6">
                            <FormattedText value="historic-tooltipTotalLabel" />
                        </span>
                        <span className="col-xs-6">
                            <OneLineSymbolAmount
                                language={getLanguage()}
                                positiveAmount
                                amountObject={{
                                    amount: this.getTotalDetail(payload),
                                    currencySymbol: currency,
                                }}
                                amountObjectFormatted={{
                                    currencySymbol: currency,
                                }}
                            />
                        </span>
                    </div>
                </div>
                {payload.map(payload => {
                    if (payload.dataKey === 'TotalLastYear') {
                        return (
                            <div className="chart-tooltip__last-year-information">
                                <div className="row">
                                    {periodTime === 'M' && (
                                        <span className="col-xs-6">
                                            <FormattedText value="historic-tooltipTotalLabel" />{' '}
                                            {payload.payload.name}{' '}
                                            {payload.payload.year - 1}
                                        </span>
                                    )}
                                    {periodTime === 'D' && (
                                        <span className="col-xs-6">
                                            <FormattedText value="historic-tooltipTotalLabel" />
                                            {title}
                                        </span>
                                    )}
                                    <span className="col-xs-6">
                                        <OneLineSymbolAmount
                                            language={getLanguage()}
                                            positiveAmount
                                            amountObject={{
                                                amount: payload.value,
                                                currencySymbol: currency,
                                            }}
                                            amountObjectFormatted={{
                                                currencySymbol: currency,
                                            }}
                                        />
                                    </span>
                                </div>
                            </div>
                        );
                    }
                })}
            </div>
        );
    }
}

chartTooltip.propTypes = {
    payload: PropTypes.array,
    label: PropTypes.string,
    currency: PropTypes.string,
    type: PropTypes.string.isRequired,
    periodTime: PropTypes.string,
    hasDebit: PropTypes.bool,
    hasCredit: PropTypes.bool,
};

module.exports = chartTooltip;
